<div [formGroup]="form">
  <div class="custom-form-field__upload-container">
    <div class="custom-form-field__upload-header">
      <label
        for="{{ item.formControlName }}"
        class="custom-form-field__label"
      >{{ item.label }}</label>

      <p-button
        iconPos="left"
        class="custom-form-field__upload-button"
        [icon]="uploader.files.length ? 'pi pi-times' : 'pi pi-plus-circle'"
        [label]="(uploader.files.length ? 'REMOVE_UPLOADED_TITLE' : 'UPLOAD_TITLE') | translate"
      >
        <p-fileUpload
          #uploader
          name="{{ item.formControlName }}[]"
          mode="basic"
          [customUpload]="true"
          [attr.aria-describedby]="item.formControlName + '-error'"
          [accept]="item?.fileTypesAccept"
          (onSelect)="fileProcessing(
            item.formControlName,
            item.label,
            $event,
            formData?.options?.loadFileType
          )"
          class="custom-form-field__uploader"
          [multiple]="item.type === 'file-multi'"
          (uploadHandler)="uploader.clear()"
        ></p-fileUpload>
      </p-button>

    </div>


    <ul class="custom-form-field__selected-files">
      <li
        *ngFor="let file of uploader.files"
        class="custom-form-field__selected-file"
      >
        <i class="pi pi-file"></i>
        {{ file.name }}
      </li>
    </ul>
  </div>
  <input type="hidden" [formControlName]="item.formControlName" />
  <small
    *ngIf="
      item.hintMessage &&
        !(
          item.errorMessage &&
          form.get(item.formControlName).errors &&
          Object.keys(form.get(item.formControlName).errors).length &&
          form.get(item.formControlName).touched
        )
    "
    id="{{ item.formControlName }}-hint"
    class="block"
  >
    {{ item.hintMessage }}
  </small>
  <small
    *ngIf="
      item.errorMessage &&
      form.get(item.formControlName).errors &&
      Object.keys(form.get(item.formControlName).errors).length &&
      form.get(item.formControlName).touched
    "
    id="{{ item.formControlName }}-error"
    class="p-error block"
  >
    {{ item.errorMessage }}
  </small>
</div>
